import { observer } from 'mobx-react-lite'
import { EmptyState } from 'shared/ui'
import reviewsPreviewImg from 'shared/assets/images/reviews/reviews_preview.png'
import { getCDNAssetURL } from 'shared/lib'
import { GuideButton, NewReviewButton } from 'pages/reviews/ui/ReviewsActions/ReviewsActions'
import styles from './styles.module.scss'

export const ReviewsPageEmpty = observer(() => (
  <EmptyState
    variant={'preview'}
    previewImg={<img alt='Reviews preview' src={getCDNAssetURL(reviewsPreviewImg)} />}
    title={'Create your first review page'}
    subtitle={'Link your review accounts and gather feedback easily'}
    actions={
      <>
        <NewReviewButton />
        <GuideButton className={styles.helpGuideButton} />
      </>
    }
  />
))
